import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { buildApiUrl } from "../utils/api";

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/");
        }
    }, []);


    const handleLogin = async (values) => {
        setLoading(true);
        try {
            const response = await fetch(
                buildApiUrl('/api/users/login'),
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        username: values.username,
                        password: values.password,
                    }),
                }
            );
            const data = await response.json();
            if (response.ok) {
                console.log("data", data.userData.username)
                message.success("Login successful!");
                localStorage.setItem("token", data.token);
                localStorage.setItem("role", data.userData.role);
                localStorage.setItem("userid", data.userData._id);
                localStorage.setItem("userName", data.userData.username);
                navigate("/");
            } else {
                message.error(data.message || "Invalid username or password!");
            }
        } catch (error) {
            message.error("Login failed. Please try again later.");
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="flex flex-col h-screen bg-white">

            <div className="flex items-center justify-between px-6 py-3 border-b">
                <img src="/logo.png" alt="DE Logo" className="h-8 w-auto" />
            </div>


            <div className="flex flex-1 items-center justify-center">
                <div className="w-full max-w-sm">
                    <h2 className="text-[24px]  text-gray-800">Login to</h2>
                    <p className="text-[24px] font-semibold text-gray-800 mb-6">
                        Project Tracker
                    </p>

                    <Form layout="vertical" onFinish={handleLogin}>
                        <Form.Item
                            label="Email"
                            name="username"
                            required={false}
                            rules={[{ required: true, message: "Please enter your email" }]}
                        >
                            <Input
                                placeholder="Enter Email"
                                className="py-2"
                                size="large"
                            />
                        </Form.Item>


                        <Form.Item
                            label="Password"
                            name="password"
                            required={false}
                            rules={[{ required: true, message: "Please enter your password" }]}
                        >
                            <Input.Password
                                placeholder="Enter Password"
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                                size="large"
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            className="w-full !bg-[#0D2B52] hover:!bg-[#173E73] text-white text-base h-10 rounded"
                        >
                            Log in
                        </Button>


                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Login;
